export const translations = {
  en: {
    // Header
    search: "Search",
    notifications: "Notifications",
    profile: "Profile",
    inviteText: "Want to join the platform?",
    
    // Hero
    play: "Play",
    moreInfo: "More Info",
    
    // Content sections
    trending: "Trending Now",
    popular: "Popular",
    newReleases: "New Releases",
    featured: "Featured",
    myList: "My List",
    continueWatching: "Continue Watching",
    
    // Movie Modal
    close: "Close",
    watchNow: "Watch Now",
    addToList: "Add to My List",
    removeFromList: "Remove from My List",
    
    // Registration
    registrationTitle: "Join the Platform",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    submit: "Submit",
    cancel: "Cancel",
    
    // Common
    loading: "Loading...",
    error: "An error occurred",
    noResults: "No results found",
    
    // Language
    language: "Language",
    english: "English",
    french: "French",
    spanish: "Spanish",
  },
  fr: {
    // Header
    search: "Rechercher",
    notifications: "Notifications",
    profile: "Profil",
    inviteText: "Envie de rejoindre la plateforme ?",
    
    // Hero
    play: "Lecture",
    moreInfo: "Plus d'infos",
    
    // Content sections
    trending: "Tendances",
    popular: "Populaire",
    newReleases: "Nouveautés",
    featured: "À la une",
    myList: "Ma liste",
    continueWatching: "Continuer à regarder",
    
    // Movie Modal
    close: "Fermer",
    watchNow: "Regarder maintenant",
    addToList: "Ajouter à ma liste",
    removeFromList: "Retirer de ma liste",
    
    // Registration
    registrationTitle: "Rejoindre la plateforme",
    email: "Email",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    submit: "Envoyer",
    cancel: "Annuler",
    
    // Common
    loading: "Chargement...",
    error: "Une erreur s'est produite",
    noResults: "Aucun résultat trouvé",
    
    // Language
    language: "Langue",
    english: "Anglais",
    french: "Français",
    spanish: "Espagnol",
  },
  es: {
    // Header
    search: "Buscar",
    notifications: "Notificaciones",
    profile: "Perfil",
    inviteText: "¿Quieres unirte a la plataforma?",
    
    // Hero
    play: "Reproducir",
    moreInfo: "Más información",
    
    // Content sections
    trending: "Tendencias",
    popular: "Popular",
    newReleases: "Novedades",
    featured: "Destacados",
    myList: "Mi lista",
    continueWatching: "Seguir viendo",
    
    // Movie Modal
    close: "Cerrar",
    watchNow: "Ver ahora",
    addToList: "Añadir a mi lista",
    removeFromList: "Quitar de mi lista",
    
    // Registration
    registrationTitle: "Unirse a la plataforma",
    email: "Correo electrónico",
    password: "Contraseña",
    confirmPassword: "Confirmar contraseña",
    submit: "Enviar",
    cancel: "Cancelar",
    
    // Common
    loading: "Cargando...",
    error: "Ocurrió un error",
    noResults: "No se encontraron resultados",
    
    // Language
    language: "Idioma",
    english: "Inglés",
    french: "Francés",
    spanish: "Español",
  },
};
